import axios from "axios";
import {clearToken} from "./tokenUtil";
import {clearLocalStorageExceptTableConfigs} from "./localStorageUtils";

let store;
export const injectStore = _store => {
    store = _store
};

const defaultBaseUrl = "https://dk-be-v2-stage.skemasoft.com/api/";
const version = "0.0.1";
const APIV2 = axios.create({
    baseURL: process.env?.REACT_APP_API_V2_BASE_URL ?? defaultBaseUrl,
    responseType: "json",
    timeout: 20000,
    headers: {
        "Content-Type": "application/json",
        "X-Accept-Version": version
    },
});

APIV2.interceptors.request.use(async function (req) {
    if (store.getState().user.token !== null) {
        req.headers.Authorization = 'Bearer '+store.getState().user.token;
    }
    return req;
});


APIV2.interceptors.response.use(
    function (response) {
        //console.log(response);
        return response.data;
    },function (error) {
        if (error.response){



            let status = 0;
            let message = '';
            if (error.response != null && error.response.data != null) {
                status = error.response.data.code;
                message = error.response.data.message;
                if(error.response.data.validation != null){
                    message = error.response.data.validation[0];
                }
            }

            if(store.getState().user.token && status === 401){
                clearToken();
                clearLocalStorageExceptTableConfigs();
                window.location.reload();
            }

            return Promise.reject({ code: status, message: message });
        }else if(error.request){
            //console.log(error.request);
        }else if(error.message){
            return Promise.reject({ code: 0, message: 'Request Canceled' });
        }

    }
);

export default APIV2;
